import React, { useState } from 'react';
import './Pricing.css';

const Pricing = () => {
  const [activeTab, setActiveTab] = useState('bamtai');

  const bamTaiData = [
    {
      stt: 1,
      maSP: 'S6-1P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 5,95kW-1P',
      congSuat: 5.95,
      thanhTien: 53550000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 2,
      maSP: 'S8-1P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 9,52kW-1P',
      congSuat: 8.33,
      thanhTien: 74970000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 3,
      maSP: 'S11-1P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 11.9kW-1P',
      congSuat: 10.71,
      thanhTien: 91035000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 4,
      maSP: 'S11-3P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 11.9kW-3P',
      congSuat: 10.71,
      thanhTien: 91035000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 5,
      maSP: 'S17-3P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 17.85kW-3P',
      congSuat: 17.85,
      thanhTien: 151725000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 6,
      maSP: 'S22-3P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 22.61kW-3P',
      congSuat: 22.61,
      thanhTien: 180880000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 7,
      maSP: 'S34-3P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 34.51kW-3P',
      congSuat: 34.51,
      thanhTien: 276080000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 8,
      maSP: 'S55-3P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 54.9kW-3P',
      congSuat: 54.74,
      thanhTien: 437920000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 9,
      maSP: 'S92-3P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 90.44kW-3P',
      congSuat: 91.5,
      thanhTien: 732000000,
      bienTan: 'GROWATT',
    },
    {
      stt: 10,
      maSP: 'S120-3P',
      tenGoi: 'HỆ THỐNG - HÒA LƯỚI, BÁM TẢI 117.215kW-3P',
      congSuat: 118.95,
      thanhTien: 951600000,
      bienTan: 'GROWATT',
    },
  ];

  const luuTruData = [
    {
      stt: 1,
      maSP: 'SHB5-1P',
      tenGoi: 'HỆ THỐNG - HYBRID 5.95kW-1P',
      congSuat: 5.49,
      thanhTien: 82350000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 2,
      maSP: 'SHB8-1P',
      tenGoi: 'HỆ THỐNG - HYBRID 8.33kW-1P',
      congSuat: 8.54,
      thanhTien: 128100000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 3,
      maSP: 'SHB11-3P',
      tenGoi: 'HỆ THỐNG - HYBRID 11.9kW-3P',
      congSuat: 10.98,
      thanhTien: 164700000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 4,
      maSP: 'SHB15-1P',
      tenGoi: 'HỆ THỐNG - HYBRID 14.64kW-1P',
      congSuat: 14.64,
      thanhTien: 219600000,
      bienTan: 'DEYE / LUXPOWER',
    },
    {
      stt: 5,
      maSP: 'SHB15-3P',
      tenGoi: 'HỆ THỐNG - HYBRID 14.64kW-3P',
      congSuat: 14.64,
      thanhTien: 219600000,
      bienTan: 'DEYE / LUXPOWER',
    },
  ];

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('vi-VN').format(value);
  };

  const renderPricingCards = (data) => {
    return data.map((item, index) => (
      <div
        key={item.stt}
        className={`pricing-card ${index === Math.floor(data.length / 2) ? 'pricing-card--featured' : ''}`}
        data-aos="fade-up"
        data-aos-delay={index * 80}
      >
        {index === Math.floor(data.length / 2) && (
          <div className="pricing-card__badge">Phổ biến</div>
        )}
        <div className="pricing-card__header">
          <span className="pricing-card__code">{item.maSP}</span>
          <div className="pricing-card__power">
            <span className="pricing-card__power-value">{item.congSuat}</span>
            <span className="pricing-card__power-unit">kWp</span>
          </div>
        </div>
        <div className="pricing-card__body">
          <h4 className="pricing-card__name">{item.tenGoi}</h4>
          <div className="pricing-card__price">
            <span className="pricing-card__price-value">
              {formatCurrency(item.thanhTien)}
            </span>
            <span className="pricing-card__price-currency">VNĐ</span>
          </div>
          <div className="pricing-card__inverter">
            <i className="fas fa-microchip"></i>
            <span>Biến tần: {item.bienTan}</span>
          </div>
        </div>
        <div className="pricing-card__footer">
          <a href="#contact" className="pricing-card__btn">
            <i className="fas fa-phone-alt"></i>
            Liên hệ tư vấn
          </a>
        </div>
      </div>
    ));
  };

  const renderPricingTable = (data) => {
    return (
      <div className="pricing-table-wrapper">
        <table className="pricing-table">
          <thead>
            <tr>
              <th className="pricing-table__th pricing-table__th--stt">STT</th>
              <th className="pricing-table__th pricing-table__th--code">Mã SP</th>
              <th className="pricing-table__th pricing-table__th--name">Tên gói sản phẩm</th>
              <th className="pricing-table__th pricing-table__th--power">Công suất (kWp)</th>
              <th className="pricing-table__th pricing-table__th--price">Thành tiền (VNĐ)</th>
              <th className="pricing-table__th pricing-table__th--inverter">Biến tần sử dụng</th>
              <th className="pricing-table__th pricing-table__th--action"></th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={item.stt}
                className="pricing-table__row"
                data-aos="fade-up"
                data-aos-delay={index * 50}
              >
                <td className="pricing-table__td pricing-table__td--stt">{item.stt}</td>
                <td className="pricing-table__td pricing-table__td--code">
                  <span className="pricing-table__code-badge">{item.maSP}</span>
                </td>
                <td className="pricing-table__td pricing-table__td--name">{item.tenGoi}</td>
                <td className="pricing-table__td pricing-table__td--power">
                  <span className="pricing-table__power-highlight">{item.congSuat}</span>
                </td>
                <td className="pricing-table__td pricing-table__td--price">
                  <span className="pricing-table__price-highlight">
                    {formatCurrency(item.thanhTien)}
                  </span>
                </td>
                <td className="pricing-table__td pricing-table__td--inverter">{item.bienTan}</td>
                <td className="pricing-table__td pricing-table__td--action">
                  <a href="#contact" className="pricing-table__contact-btn">
                    Tư vấn
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <section id="pricing" className="pricing-section">
      <div className="pricing-bg-shapes">
        <div className="pricing-bg-shape pricing-bg-shape--1"></div>
        <div className="pricing-bg-shape pricing-bg-shape--2"></div>
        <div className="pricing-bg-shape pricing-bg-shape--3"></div>
      </div>

      <div className="container">
        {/* Section Header */}
        <div className="section-header" data-aos="fade-up">
          <span className="section-tag">
            <i className="fas fa-tags"></i> BẢNG GIÁ
          </span>
          <h2 className="section-title">
            BÁO GIÁ HỆ THỐNG ĐIỆN NĂNG LƯỢNG MẶT TRỜI
          </h2>
          <p className="section-description">
            G-Nine Solar cung cấp giải pháp điện mặt trời với mức giá cạnh tranh, chất lượng vượt trội
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="pricing-tabs" data-aos="fade-up" data-aos-delay="100">
          <button
            className={`pricing-tab ${activeTab === 'bamtai' ? 'pricing-tab--active' : ''}`}
            onClick={() => setActiveTab('bamtai')}
          >
            <div className="pricing-tab__icon">
              <i className="fas fa-solar-panel"></i>
            </div>
            <div className="pricing-tab__content">
              <span className="pricing-tab__title">Hệ Thống Bám Tải</span>
              <span className="pricing-tab__subtitle">Hòa lưới - Không lưu trữ</span>
            </div>
          </button>
          <button
            className={`pricing-tab ${activeTab === 'luutru' ? 'pricing-tab--active' : ''}`}
            onClick={() => setActiveTab('luutru')}
          >
            <div className="pricing-tab__icon">
              <i className="fas fa-battery-full"></i>
            </div>
            <div className="pricing-tab__content">
              <span className="pricing-tab__title">Hệ Thống Lưu Trữ</span>
              <span className="pricing-tab__subtitle">Hybrid - Có pin lưu trữ</span>
            </div>
          </button>
        </div>

        {/* Pricing Cards (visible on mobile) */}
        <div className="pricing-cards-container">
          <div className="pricing-cards-grid">
            {activeTab === 'bamtai'
              ? renderPricingCards(bamTaiData)
              : renderPricingCards(luuTruData)}
          </div>
        </div>

        {/* Pricing Table (visible on desktop) */}
        <div className="pricing-table-container" data-aos="fade-up" data-aos-delay="200">
          {activeTab === 'bamtai'
            ? renderPricingTable(bamTaiData)
            : renderPricingTable(luuTruData)}
        </div>

        {/* Custom Pricing Note */}
        <div className="pricing-note" data-aos="fade-up" data-aos-delay="300">
          <div className="pricing-note__icon">
            <i className="fas fa-info-circle"></i>
          </div>
          <div className="pricing-note__content">
            <p className="pricing-note__text">
              {activeTab === 'bamtai'
                ? 'Với công suất từ 118,95 kW trở lên, vui lòng liên hệ để nhận báo giá tốt nhất.'
                : 'Với công suất từ 17,08 kW trở lên, vui lòng liên hệ để nhận báo giá tốt nhất. Biến tần sử dụng: DEYE / GROWATT.'}
            </p>
            <a href="#contact" className="pricing-note__link">
              <i className="fas fa-arrow-right"></i> Liên hệ báo giá
            </a>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="pricing-trust" data-aos="fade-up" data-aos-delay="400">
          <div className="pricing-trust__item">
            <i className="fas fa-shield-alt"></i>
            <span>Bảo hành lên đến 25 năm</span>
          </div>
          <div className="pricing-trust__item">
            <i className="fas fa-truck"></i>
            <span>Miễn phí vận chuyển & lắp đặt</span>
          </div>
          <div className="pricing-trust__item">
            <i className="fas fa-hand-holding-usd"></i>
            <span>Hỗ trợ trả góp 0%</span>
          </div>
          <div className="pricing-trust__item">
            <i className="fas fa-headset"></i>
            <span>Hỗ trợ kỹ thuật 24/7</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;